import { getProductBlockVariantInfo } from '@grandvisionhq/products';
import { formatPrice, mapProductTypeToProductCategory } from '@grandvisionhq/svc-tealium/utils';

const mapProductToTealiumProperties = (product)=>{
    const productTypeName = product.productType;
    const variantInfo = getProductBlockVariantInfo(product, product.masterVariant, productTypeName);
    let originalPrice = '';
    let discountedPrice = '';
    if (variantInfo.price) {
        originalPrice = formatPrice(variantInfo.price, true);
        var _discountedPrice;
        discountedPrice = formatPrice((_discountedPrice = variantInfo.discountedPrice) !== null && _discountedPrice !== void 0 ? _discountedPrice : variantInfo.price, true);
    }
    const isLenses = productTypeName === 'Contact-lenses' || productTypeName === 'Contact-lens-bundles';
    const isProductWithAFrame = productTypeName === 'Frames' || productTypeName === 'Sunglasses' || productTypeName === 'Ready-readers';
    const productProperties = {
        Category: mapProductTypeToProductCategory(productTypeName),
        Price: discountedPrice,
        PriceFull: originalPrice,
        ModelName: isLenses ? variantInfo.brand : variantInfo.name
    };
    if (isProductWithAFrame || isLenses) {
        productProperties.LensType = 'PLANO';
    }
    return productProperties;
};

export { mapProductToTealiumProperties };
//# sourceMappingURL=map-product-to-tealium-properties.js.map
